<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-07 17:06:32
 * @Description: 鲸鱼优选首页
 -->

<template>
  <div class="detail-content-wrapper">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'm-detail-content'
};
</script>
